import styled from 'styled-components';

// Define base styles
const baseStyles = `
  margin: 0;
`;

// Helper function to create a typography component
const createTypographyComponent = (Element, defaultStyles) => {
    return styled(Element)`
        ${baseStyles}
        ${defaultStyles}
    color: ${(props) => props.color};
        font-weight: ${(props) => props.fontWeight};
        font-size: ${(props) => props.fontSize};
    `;
};

// Heading components
// 40-48px => 48px Desktop 700
export const H1 = createTypographyComponent(
    'h1',
    `
font-family: 'Nunito', sans-serif;
font-weight: 700;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 2.5rem; /* 40px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 2.75rem; /* 44px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 3rem; /* 48px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 3rem; /* 48px */
}
`
);

// 32-40px => 40px Desktop 600
export const H2 = createTypographyComponent(
    'h2',
    `
font-family: 'Nunito', sans-serif;
font-weight: 600;
color: #F5F5F5;

/* Mobile Devices */

@media (min-width: 320px) and (max-width: 480px) {
  font-size: 2rem; /* 32px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 2.25rem; /* 36px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 2.5rem; /* 40px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 2.5rem; /* 40px */
}
`
);

// 24-32px => 32px Desktop 500
export const H3 = createTypographyComponent(
    'h3',
    `
font-family: 'Nunito', sans-serif;
font-weight: 500;
color:#F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 1.5rem; /* 24px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 1.75rem; /* 28px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 2rem; /* 32px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 2rem; /* 32px */
}
`
);

// 20-24px => 24px Desktop 500
export const H4 = createTypographyComponent(
    'h4',
    `
font-family: 'Nunito', sans-serif;
font-weight: 500;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 1.25rem; /* 20px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 1.375rem; /* 22px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 1.5rem; /* 24px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 1.5rem; /* 24px */
}
`
);

// 18-20px => 20px Desktop 400
export const H5 = createTypographyComponent(
    'h5',
    `
font-family: 'Nunito', sans-serif;
font-weight: 600;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 1.125rem; /* 18px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 1.1875rem; /* 19px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 1.25rem; /* 20px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 1.25rem; /* 20px */
}
`
);

// 16-20px => 18px Desktop 600
export const H6 = createTypographyComponent(
    'h6',
    `
font-family: 'Nunito', sans-serif;
font-weight: 600;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 1rem; /* 16px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 1.0625rem; /* 17px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 1.125rem; /* 18px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 1.125rem; /* 18px */
}
`
);

// 16-20px => 18px Desktop 600
export const H7 = createTypographyComponent(
    'h6',
    `
font-family: 'Nunito', sans-serif;
font-weight: 600;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 1rem; /* 16px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 1.0625rem; /* 17px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 1.125rem; /* 18px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 1rem; /* 16px */
}
`
);

// Text components
// 16-18px => 18px Desktop 400
export const Body1 = createTypographyComponent(
    'p',
    `
font-family: 'Noto Sans', sans-serif;
font-weight: 400;
line-height: 1.3;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 1rem; /* 16px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 1.0625rem; /* 17px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 1.125rem; /* 18px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 1.125rem; /* 18px */
}
`
);

// 14-16px => 16px Desktop 400
export const Body2 = createTypographyComponent(
    'p',
    `
font-family: 'Noto Sans', sans-serif;
font-weight: 400;
line-height: 1.3;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 0.875rem; /* 14px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 0.9375rem; /* 15px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 1rem; /* 16px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 1rem; /* 16px */
}
`
);

// 12-14px => 14px Desktop 300
export const Body3 = createTypographyComponent(
    'p',
    `
font-family: 'Noto Sans', sans-serif;
font-weight: 300;
line-height: 1.3;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 0.875rem; /* 14px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 0.8125rem; /* 13px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 0.875rem; /* 14px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 0.875rem; /* 14px */
}
`
);

// 12-14px => 12px Desktop 300
export const Body4 = createTypographyComponent(
    'p',
    `
font-family: 'Noto Sans', sans-serif;
font-weight: 300;
line-height: 1.3;
color: #F5F5F5;

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  font-size: 0.875rem; /* 14px */
}

/* iPads and Tablets */
@media (min-width: 481px) {
  font-size: 0.8125rem; /* 13px */
}

/* Laptops and small screens */
@media (min-width: 769px) {
  font-size: 0.875rem; /* 14px */
}

/* Large screens and Desktops */
@media (min-width: 1025px) {
  font-size: 0.8rem; /* 12px */
}
`
);

// Used as label
export const Subtitle1 = createTypographyComponent(
    'p',
    `
  font-family: 'Noto Sans', sans-serif;
  font-size: 1.3rem;
  font-weight: 500;
  color: #FFFFFF;
  @media (min-width: 600px) { font-size: 1.5rem; }
  @media (min-width: 960px) { font-size: 1.5rem; }
`
);

export const Subtitle2 = createTypographyComponent(
    'p',
    `
  font-family: 'Noto Sans', sans-serif;
  font-size: 1.125rem;
  font-weight: 400;
  color: #FFFFFF;
  @media (min-width: 600px) { font-size: 1.125rem; }
  @media (min-width: 960px) { font-size: 1.125rem; }
`
);

export const Caption = createTypographyComponent(
    'p',
    `
  font-family: 'Noto Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 300;
  color: #FFFFFF;
`
);

export const Button = createTypographyComponent(
    'span',
    `
  font-family: 'Noto Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #FFFFFF;
  @media (min-width: 600px) { font-size: 1rem; }
  @media (min-width: 960px) { font-size: 1.125rem; }
`
);

export const SpanText = createTypographyComponent(
    'span',
    `
font-family: 'Noto Sans', sans-serif;
font-size: 0.875rem;
font-weight: 500;
color: #FFFFFF;
@media (min-width: 600px) { font-size: 0.875rem; }
@media (min-width: 960px) { font-size: 0.875rem; }
`
);

// Global style component
export const TypographyStyle = styled.div`
    font-family: 'Noto Sans', sans-serif;
    color: #ffffff;

    /* You can add more global styles here if needed */
`;
